<template>
  <div class="homeBox" ref="homeBox">
    <!--    banner     -->
    <div class="banner PurchaseBanner">
      <img src="../../public/img/nbg.png" alt="">
      <div class="softScript PurchaseSoftScript">
        <div class="TipText">
          <div class="title">我在企业</div>
          <div class="line">
            <span class="blue"></span>
            <span class="yellow"></span>
            <span class="green"></span>
          </div>
          <div class="script">
            除了基本的个人信息之外，可以帮你设定每日、每周、每月相关的工作计划，<br>
            自己的任务安排、其他同事 分派的事项以及根据权限你可以对一些人员<br>
            提交的事项进行审批。除此之外还包括日报、周报、月报、 年度的工作<br>
            汇报等。还能每天都清楚知道自己收到那些任务，让你自由掌握，<br>
            第一时间推进 重要事情。管 理层还可以对任务进行分解。
          </div>
          <div class="start">
            <a href="javascript:;" onclick="window.open('http://www.teamrobotics.net/project')">
              开始吧
              <img src="../../public/img/right.png" alt="">
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="SolveQuestion PurchaseQuestion">
      <div class="w1200">
        <div class="clearfix Sales">
          <div class="l">
            <img src="../../public/img/n1.png" alt="">
          </div>
          <div class="r">
            <div class="icon">
              <img src="../../public/img/nicon1.png" alt="">
            </div>
            <div class="tip">
              工作日程
            </div>
            <div class="list">
              <ul>
                <li>
                  <a href="javascript:;">
                    <div>
                      <span class="triangle-right"></span>
                      通过日历视图直观的展现一天或一周的日
                      程安排，合理规划手头任务，重要的事一
                      目了然。确保安排的日程不会与其他日程
                      冲突
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="clearfix Progress">
          <div class="l">
            <img src="../../public/img/n2.png" alt="">
          </div>
          <div class="r">
            <div class="icon">
              <img src="../../public/img/nicon2.png" alt="">
            </div>
            <div class="tip">
              我的审批
            </div>
            <div class="list">
              <ul>
                <li>
                  <a href="javascript:;">
                    <div>
                      <span class="triangle-right"></span>
                      对工作人员提交的立项申请、工作汇报，物料
                      采购、物料申领、物料变更、费用申请等各项
                      审批工作，支持完成批量审批操作;
                    </div>
                  </a>
                </li>
                <li>
                  <a href="javascript:;">
                    <div>
                      <span class="triangle-right"></span>
                      移动审批：让报销流程更快全程在线，合规高
                      效，财务、员工皆满意
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="clearfix Purchase">
          <div class="l">
            <img src="../../public/img/n3.png" alt="">
          </div>
          <div class="r">
            <div class="icon">
              <img src="../../public/img/nicon3.png" alt="">
            </div>
            <div class="tip">
              工作汇报
            </div>
            <div class="list">
              <ul>
                <li>
                  <a href="javascript:;">
                    <div>
                      <span class="triangle-right"></span>
                      执行人员对自己每天推进了哪些项目、完
                      成了多少任务，解决了哪些项目问题，完
                      成的进度多少，以及其他工作项的汇报。
                      而且还能同步到企业圈向领导、关注你的
                      同事展现当天的工作成就，并分享下工作
                      过程。
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="clearfix Progress GetMetarial">
          <div class="l">
            <img src="../../public/img/n4.png" alt="">
          </div>
          <div class="r">
            <div class="icon">
              <img src="../../public/img/nicon4.png" alt="">
            </div>
            <div class="tip">
              我的任务
            </div>
            <div class="list">
              <ul>
                <li>
                  <a href="javascript:;">
                    <div>
                      <span class="triangle-right"></span>
                      员工每天能清楚的知道，给自己分配了
                      那些任务，并知道任务的优先级，合理
                      安排工作的急重缓轻。遇到问题时，将
                      任务分配下去，相关人员马上就能收到，
                      后续的进展也可以随时了解。
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="clearfix Purchase">
          <div class="l">
            <img src="../../public/img/n5.png" alt="">
          </div>
          <div class="r">
            <div class="icon">
              <img src="../../public/img/nicon5.png" alt="">
            </div>
            <div class="tip">
              发起申请
            </div>
            <div class="list">
              <ul>
                <li>
                  <a href="javascript:;">
                    <div>
                      <span class="triangle-right"></span>
                      请假申请：员工有事不能按时上班，需要
                      请假可以发起请假申请
                    </div>
                  </a>
                </li>
                <li>
                  <a href="javascript:;">
                    <div>
                      <span class="triangle-right"></span>
                      外出申请：当员工需要去拜见客户或上门
                      做服务需要外出可以发起外出申请
                    </div>
                  </a>
                </li>
                <li>
                  <a href="javascript:;">
                    <div>
                      <span class="triangle-right"></span>
                      费用申请：做项目需要启动资金或项目日
                      常开销需要费用可以发起费用申请
                    </div>
                  </a>
                </li>
                <li>
                  <a href="javascript:;">
                    <div>
                      <span class="triangle-right"></span>
                      外出申请：因公出差、请客户吃饭、公司
                      活动需要报销可以发起报销申请
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="clearfix Progress GetMetarial">
          <div class="l">
            <img src="../../public/img/n6.png" alt="">
          </div>
          <div class="r">
            <div class="icon">
              <img src="../../public/img/nicon6.png" alt="">
            </div>
            <div class="tip">
              个人信息
            </div>
            <div class="list">
              <ul>
                <li>
                  <a href="javascript:;">
                    <div>
                      <span class="triangle-right"></span>
                      记录每个员工的基本信息。可以修改注册账户
                      的手机号及其登录密码和个人信息，有助于更
                      好的管理自己重要信息
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--提高效率，提高竞争力-->
    <div class="Increase PurchaseIncrease">
      <div class="w1200">
        <div class="TipText">
          <div class="title">提高效率，提高竞争力</div>
          <div class="line">
            <span class="blue"></span>
            <span class="yellow"></span>
            <span class="green"></span>
          </div>
          <div class="script">
            让每个自动化企业都享受智慧服务与数据
            带来的改变
            <div class="bottomStart"><a href="javascript:;" onclick="window.open('http://www.teamrobotics.net/project')">开始吧<img src="../../public/img/right.png" alt=""></a></div>
          </div>
        </div>
      </div>
    </div>
    <!--导航  pc+mobile-->
    <Nav></Nav>
    <!--底部-->
    <Foot></Foot>
    <!--返回头部-->
    <GoTop></GoTop>
  </div>
</template>
<script>
  import Nav from '@/components/Nav.vue'
  import GoTop from '@/components/GoTop.vue'
  import Foot from '@/components/Foot.vue'
  export default {
    name: 'InsideCompany',
    data(){
      return {
        title:"",
        desc:"",
        url:""
      }
    },
    components: {
      Nav,
      GoTop,
      Foot
    },
    computed:{

    },
    methods:{

    },
    mounted(){

    },
    activated(){

    },
    created(){

    }
  }
</script>
<style>

</style>
